export default __webpack_public_path__ + "static/media/business-commission.dab85499.jpeg";